import { useAppStructure } from "@redux/features/appStructure/useAppStructure"
import DashboardPageLayout from "@sop/DashboardPage/DashboardPageLayout"
import { createFileRoute } from "@tanstack/react-router"
import { LoadingCircle } from "@ui-lib/index"

export const Route = createFileRoute("/_sopPageLayout")({
	component: RouteComponent,
})

function RouteComponent() {
	const { data: appStruct } = useAppStructure()
	return appStruct == null ? (
		<LoadingCircle containerHeightWithUnit="100vh" />
	) : (
		<DashboardPageLayout props={appStruct} />
	)
}
